/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getSocioEcoHistoryActions, {
    getSocioEcoHistoryTypes,
} from '../../../redux/collectData/getSocioEcoHistory'
import { Get } from '../../../serveur/axios'

function* getSocioEcoHistorySagas() {
    try {
        const res = yield Get(`csv/economic_data/historique_file`)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getSocioEcoHistoryActions.getSocioEcoHistorySuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(getSocioEcoHistoryActions.getSocioEcoHistoryFailure(res))
        }
    } catch (error) {
        yield put(getSocioEcoHistoryActions.getSocioEcoHistoryFailure(error))
    }
}

export function* getSocioEcoHistorySaga() {
    yield takeLatest(
        getSocioEcoHistoryTypes.GET_SOCIO_ECO_HISTORY_REQUEST,
        getSocioEcoHistorySagas
    )
}
